import { useTranslation } from 'react-i18next';

import Accordion from '@/components/v2/UI/Accordion';

import useQueryParams from '@/hooks/useQueryParams';

const SORT_OPTIONS = ['name-asc', 'name-desc', 'price-asc', 'price-desc'];

const Sorting = () => {
  const { t } = useTranslation();
  const [query, setQuery] = useQueryParams();

  return (
    <Accordion as="ul" name={t('SORT')} className="space-y-3 py-3 px-6 xl:px-0">
      {SORT_OPTIONS.map(option => (
        <li key={option}>
          <label className="flex items-center space-x-3">
            <input
              id={option}
              type="radio"
              name="sort"
              checked={Boolean(query['sort']?.includes(option))}
              onChange={() => setQuery({ sort: option })}
              className="h-5 w-5 text-black focus:ring-black rounded-full"
            />

            <span>{t(`SORT_OPTIONS.${option}`)}</span>
          </label>
        </li>
      ))}
    </Accordion>
  );
};

export default Sorting;
